import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=c1421cb6&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderItems.vue?vue&type=style&index=0&id=c1421cb6&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1421cb6')) {
      api.createRecord('c1421cb6', component.options)
    } else {
      api.reload('c1421cb6', component.options)
    }
    module.hot.accept("./OrderItems.vue?vue&type=template&id=c1421cb6&", function () {
      api.rerender('c1421cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-requisition/components/OrderItems.vue"
export default component.exports